// Types
import { Icon as IconType } from '../../../types/icon';
import { Measurements } from '../../../types/measurements';

// Utils
import { getMeasurementBySize } from '../../../utils/icon';

// Component
import Icon from '../Icon/Icon';

const IconFire = (props: IconType) => {
  const {
    size,
    inverse,
    onClick,
    width,
    height,
    fill,
    iconClassName,
  } = props;

  const defaultMeasurements: Measurements = {
    height: 36,
    width: 36,
  }

  const measurements = size ? getMeasurementBySize(size) : defaultMeasurements;

  return (
    <Icon inverse={inverse} onClick={onClick} className={iconClassName} classNameIconType="c-icon-fire">
      <svg className='c-icon-fire fill-current' width={width || measurements.width} height={height || measurements.height} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M25.7628 17.8011C25.444 15.915 24.6879 14.1655 23.3729 12.245C23.2928 13.0342 23.2928 13.4798 23.2143 13.9255C23.0156 15.0569 21.8607 15.8461 20.5071 15.8116C19.1536 15.7771 18.1973 14.9203 18.1573 13.6854C18.1172 13.2743 18.1973 12.8286 18.2373 12.4161C18.6362 6.72179 15.9275 2.6407 9.63715 0C10.672 2.74427 10.2747 5.24711 8.72092 7.51125C7.76464 8.9862 6.64976 10.3577 5.53488 11.7305C4.33994 13.2055 2.98637 14.4748 1.9115 15.9828C-1.83199 21.0934 0.11905 28.0223 6.05233 31.0742C6.80843 31.4509 7.56603 31.7599 8.32213 32C8.08345 31.7599 7.88479 31.4854 7.68461 31.2108C6.68985 29.7704 6.37109 28.192 6.68985 26.5114C6.84846 25.5856 7.20726 24.6929 7.88479 23.7326C7.92483 24.1093 7.92483 24.3494 7.96487 24.5563C8.08498 25.1399 8.64244 25.5166 9.31844 25.4822C9.99601 25.4477 10.4734 25.0365 10.4734 24.4184C10.5134 24.2128 10.4333 24.0072 10.4333 23.7671C10.2347 20.9207 11.5883 18.9312 14.6944 17.5927C14.177 18.9642 14.3756 20.199 15.1317 21.3319C15.6091 22.0521 16.1665 22.7378 16.724 23.4236C17.3215 24.1438 17.9975 24.7951 18.5165 25.5153C19.87 27.4014 19.7114 29.7675 18.3178 31.5172C20.4675 30.5914 22.3802 29.1165 23.6937 27.1268C25.7633 24.3176 26.4009 21.1276 25.7633 17.801L25.7628 17.8011Z" fill={fill || '#f08642'} />
      </svg>
    </Icon>
  );
};

export default IconFire;
